import type { TypeTableColumn } from '@thefarmersfront/kitchen';

import { TextWithLinkCell } from '~/components/common';

import { FIRST_LINE_CELL_STYLE } from './deliveryAgencyTableCells';

import type { TypeDeliveryAgencyOrdersUploadResult } from '~/types/delivery-agency.types';

type TypeDeliveryAgencyOrdersUploadFailDetail = TypeDeliveryAgencyOrdersUploadResult['failDetails'][number];

const getDeliveryAgencyOrderExcelUploadFailColumnDefs = () => {
  const columnDefs: TypeTableColumn<TypeDeliveryAgencyOrdersUploadFailDetail>[] = [
    {
      id: 'no',
      header: 'No',
      cell: ({ row }) => row.index + 1,
      size: 72,
      meta: { cellStyle: FIRST_LINE_CELL_STYLE },
    },
    {
      accessorKey: 'rowNums',
      header: '실패 대상',
      size: 160,
      cell: ({ row }) => row.original.rowNums?.map((num: number) => `${num}행`).join(', ') ?? '-',
      meta: { overflow: 'wrap', cellStyle: FIRST_LINE_CELL_STYLE },
    },
    {
      accessorKey: 'message',
      header: '실패 사유',
      minSize: 506,
      cell: ({ row }) => <TextWithLinkCell value={row.original.message} />,
      meta: { flex: true, overflow: 'wrap', cellStyle: { padding: '5px 0' } },
    },
  ];

  return { columnDefs };
};

export default getDeliveryAgencyOrderExcelUploadFailColumnDefs;
